export default __webpack_public_path__ + "static/media/team52.d7909fbd.JPG";